import React from 'react';
import { StatusPriceChange } from '../components';
import {
  ListingFormState,
  ListingType,
  AvailabilityDetailsType,
} from '../types';
import { StyledForm } from '../StyledComponents';

type StatusPriceChangeFormProps = {
  listing: ListingFormState;
  validAvailabilities: ListingType['availability'][];
  setListing: React.Dispatch<React.SetStateAction<ListingFormState>>;
  availabilityDetails: AvailabilityDetailsType;
  setAvailabilityDetails: React.Dispatch<
    React.SetStateAction<AvailabilityDetailsType>
  >;
  initialAvailabilityDetails: AvailabilityDetailsType;
  errorMessage?: string;
};

const StatusPriceChangeForm: React.FC<StatusPriceChangeFormProps> = ({
  listing,
  setListing,
  validAvailabilities,
  availabilityDetails,
  setAvailabilityDetails,
  initialAvailabilityDetails,
  errorMessage,
}) => (
  <StyledForm>
    <StatusPriceChange
      thumbnail={listing.thumbnail}
      line1={listing.line1}
      line2={listing.line2}
      city={listing.city}
      province={listing.province}
      postal_code={listing.postal_code}
      list_price={listing.list_price}
      availability={listing.availability}
      setListing={setListing}
      validAvailabilities={validAvailabilities}
      availabilityDetails={availabilityDetails}
      setAvailabilityDetails={setAvailabilityDetails}
      initialAvailabilityDetails={initialAvailabilityDetails}
      errorMessage={errorMessage}
    />
  </StyledForm>
);

export default StatusPriceChangeForm;
